<template>
    <div class="isLoadible">
        <h3>
            <span class="title-numbering">1</span>
            {{ texts.getText('ingredients-title', 'recipe-edit') }}
        </h3>

        <p v-html="texts.getText('ingredients-intro', 'recipe-edit')"></p>

        <div class="row"  style="margin-top: 1em; margin-bottom: 1em;">
            <div class="small-12 medium-12 large-8 columns">

                <div class="ingredient">

                    <div class="ingredient__close">
                    </div>

                    <div class="ingredient__field ingredient__label">
                        <div style="text-align: left;  padding-right: 1em; color: darkgrey;">ingredience</div>
                    </div>

                    <div class="ingredient__field ingredient__unit">
                        <div style="text-align: right;  padding-right: 1em; color: darkgrey;">jednotka</div>
                    </div>

                    <div class="ingredient__field ingredient__amount">
                        <div style="text-align: right; padding-right: 1em; color: darkgrey;">množství</div>
                    </div>

                    <div style="clear: both;"></div>
                </div>

                <div>
                    <bao-ingredient
                            v-for="(attachedIngredient, index) in ingredientsStore.state.ingredients"
                            :key="index"
                            :index="index"
                            v-on:remove="ingredientsStore.removeIngredient(index)"
                    >
                        {{attachedIngredient.ingredient.label}}
                    </bao-ingredient>
                </div>

                <bao-ingredient-picker
                        @item-selected="addIngredient"
                        :options="options"
                ></bao-ingredient-picker>
            </div>
            <div class="large-4 columns show-for-large">
                <img src="/themes/nutristopa/assets/img/default-recipe.png" alt="" v-show="!image">
                <img :src="image" v-show="image">
            </div>
        </div>

        <div class="loadingOverlay" v-show="isLoading">
            <div class="spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
            </div>
        </div>

    </div>
</template>

<script>
    import _ from 'lodash';
    import axios from 'axios';

    import BaoIngredient from './ingredient';
    import BaoIngredientPicker from './ingredient-picker';
    import IngredientsStore from '../srores/ingredients-store.js'
    import TextStore from '../srores/text-store';

    export default {

        components: {
            BaoIngredient,
            BaoIngredientPicker
        },

        props: [ 'image' ],

        data() {
            return {
                ingredientsStore: IngredientsStore,
                ingredientList: [],
                isLoading: false,
                texts: TextStore,
            }
        },

        computed: {
            options() {
                let output = [];

                this.ingredientList.forEach(function (ingredient){
                    output.push({
                        value: parseInt(ingredient.id),
                        text: ingredient.label
                    });
                });

                return output;
            }
        },

        mounted() {
            let vm = this;

            this.isLoading = true;
            axios.get('/api/ingredients')
                .then(function (response) {

                    let data = response.data.data;

                    console.log(data)

                    vm.ingredientList = data;
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    vm.isLoading = false;
                });
        },

        methods: {
            addIngredient(ingredientId) {
                console.log(ingredientId);

                let selectedIngredient = _.find(this.ingredientList, {id: ingredientId});
                this.ingredientsStore.addIngredient(selectedIngredient);
            }
        }
    }
</script>

<style>
    .isLoadible {
        position:relative;
    }

    .loadingOverlay {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        opacity: 0.5;
        z-index: 100;
        display: flex;
        justify-content: center; /* align horizontal */
        align-items: center; /* align vertical */
    }

    .spinner {
        width: 40px;
        height: 40px;
        z-index: 110;
        position: relative;
        margin: auto;
    }

    .double-bounce1, .double-bounce2 {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background-color: #1c651c;
        opacity: 0.6;
        position: absolute;
        top: 0;
        left: 0;

        -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
        animation: sk-bounce 2.0s infinite ease-in-out;
    }

    .double-bounce2 {
        -webkit-animation-delay: -1.0s;
        animation-delay: -1.0s;
    }

    @-webkit-keyframes sk-bounce {
        0%, 100% { -webkit-transform: scale(0.0) }
        50% { -webkit-transform: scale(1.0) }
    }

    @keyframes sk-bounce {
        0%, 100% {
            transform: scale(0.0);
            -webkit-transform: scale(0.0);
        } 50% {
              transform: scale(1.0);
              -webkit-transform: scale(1.0);
          }
    }

    .ingredient-list {
        padding: 0.5em 0;
        margin-top: 2em;
    }

    .ingredient-list input, .ingredient select, .ingredient button {
        margin-bottom: 0;
    }

    .ingredient-list:hover {
        background-color: #f5f5f5;
    }

    .ingredient-list__field {
        float: right;
        margin-right: 0.5em;
    }

    .ingredient__label {
        float: left;
        margin-right: 0.5em;
    }


    .ingredient-list__amount {
        width: 80px;
    }

    .ingredient-list__unit {
        width: 200px;
    }

    .ingredient-list__label {
        float: left;
        width: 200px;
        padding-left: 0.5em;
        padding-top: 0.5em;
    }

    .ingredient-list__close {
        float: right;
        padding-right: 0.5em;
        padding-top: 0.5em;
        cursor: pointer;
    }
</style>
